import { render, staticRenderFns } from "./regComponent.vue?vue&type=template&id=6d8e07cd&"
import script from "./regComponent.vue?vue&type=script&lang=js&"
export * from "./regComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports